import { AxiosResponse } from 'axios';

export enum Scope {
  ALARM = 'alarm',
  CONDITION_DEVIATION = 'ConditionDeviation',
  CASE = 'Case',
  GENERIC = 'generic',
}
export enum GenericCategory {
  ATTACHED_FILE = 'attached_file',
  DETACHED_FILE = 'detached_file',
  COMMENT = 'comment',
  UPDATED = 'updated',
}
export enum Alarm {
  ALARM_CLOSED = 'alarm_closed',
  CLASSIFICATION = 'classification',
}
export enum CD {
  ACTION_STATUS_UPDATED = 'action_status_updated',
  SEVERITY_UPDATED = 'severity_updated',
  CREATED = 'created',
}
export enum Case {
  STATUS_UPDATED = 'status_updated',
  SEVERITY_UPDATED = 'severity_updated',
  CREATED = 'created',
  OWNER_UPDATED = 'owner_updated',
  ACTION_CREATED = 'action_created',
  ACTION_UPDATED = 'action_updated',
  ACTION_DELETED = 'action_deleted',
}
export const RecordCategory = { ...GenericCategory, ...Alarm, ...CD, ...Case };

export interface RecordsProps {
  eventId?: string;
}

type TypeValues<T> = T[keyof T];
export type RecordCategoryType = TypeValues<typeof RecordCategory>;

export interface CommentProps extends RecordsProps {
  text: string;
  category: RecordCategoryType;
}

export interface OptimisticRecordsCommentProps {
  user_email: string;
  comment: string;
  category: RecordCategoryType;
}
export type VoidFunc = () => void;

export enum KeyTypesUpload {
  RECORDS = 'Records',
}

export type UseMutationCallbackFunction<T> = (
  data: AxiosResponse,
  variables: T,
  context: any,
) => void;
